<template>
  <el-container style="min-height:100vh;">
    <el-header style="background:#409eff;color:#fff;display:flex;justify-content:space-between;">
      <span>商户后台</span>
      <el-button type="text" style="color:#fff;" @click="logout">退出</el-button>
    </el-header>
    <el-container>
      <el-aside width="220px" style="background:#f5f7fa;">
        <el-menu :default-active="$route.path" router>
          <el-menu-item index="/dashboard">总览</el-menu-item>
          <el-menu-item index="/agents">客服员工</el-menu-item>
          <el-menu-item index="/quick-replies">快捷回复</el-menu-item>
          <el-menu-item index="/faq">常见问题</el-menu-item>
          <el-menu-item index="/widget">网站接入</el-menu-item>
        </el-menu>
      </el-aside>
      <el-main><router-view /></el-main>
    </el-container>
  </el-container>
</template>

<script>
import { clearToken } from '../utils/auth';
export default {
  methods: {
    logout() {
      clearToken();
      this.$router.replace('/login');
    }
  }
};
</script>

